import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
// import api from "../../utils/api";

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password)
      .then(() => {
        navigate("/memarts");
      })
      .catch((err) => {
        console.log("Login failed:", err);
        // Add error handling UI here
      });
  };

  return (
    <div className='auth-container'>
      <div className='auth-card'>
        <h1 className='auth-title'>Welcome Back!</h1>
        <p className='auth-subtitle'>Please enter your details</p>

        <form onSubmit={handleSubmit} className='auth-form'>
          <div className='input-group'>
            <div className='input-icon'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              >
                <path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'></path>
                <circle cx='12' cy='7' r='4'></circle>
              </svg>
            </div>
            <input
              type='email'
              placeholder='Email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className='auth-input'
              required
            />
          </div>

          <div className='input-group'>
            <div className='input-icon'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
              >
                <rect x='3' y='11' width='18' height='11' rx='2' ry='2'></rect>
                <path d='M7 11V7a5 5 0 0 1 10 0v4'></path>
              </svg>
            </div>
            <input
              type='password'
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className='auth-input'
              required
            />
          </div>

          <button type='submit' className='auth-button'>
            Log in
          </button>

          {/* <a href='#forgot' className='forgot-link'>
            forgot password?
          </a> */}
        </form>
      </div>
    </div>
  );
};

export default Login;
